export const translations = {
  english: {
    title: "NaviBot - Human Resources ChatBot",
    welcomeMessage: "Hello, I am the NaviBot, the Human Resources ChatBot. How can I help you?",
    selectLanguageTitle: "Select Language Preference",
    selectLanguageDescription:
      "Please select the language in which you would like to receive your response.",
    selectLanguageLabel: "Select your preferred language",
    apply: "Apply",
    cancel: "Cancel",
    virtualAssistant: "A pioneering technology in constant evolution.  \nAny further questions, contact: [drh@thenavigatorcompany.com](mailto:drh@thenavigatorcompany.com)",
    anyQuestions: "Any questions? Type here",
    description: "Topic Sheet",
    showExtendedAnswer: "Show extended answer",
    hideExtendedAnswer: "Hide extended answer",
    details: "Details",
    showCitations: "Show citations",
    hideCitations: "Hide citations",
    receivedFeedback: "Feedback Received!",
    likedQuestion: "What did you like about this response?",
    dislikedQuestion: "What could be improved?",
    submit: "Submit",
    cancel: "Cancel",
    feedbackPlaceholder: "Write your feedback...",
    unclearLabel: "Unclear information",
    missingLabel: "Incomplete content",
    technicalLabel: "Too technical language",
    usefulLabel: "Useful",
    feedbackPlaceholder: "Add more details (optional)...",
    feedbackTitle: "Help us improve by rating your experience:"
  },
  portuguese: {
    title: "NaviBot - ChatBot dos RH",
    welcomeMessage: "Olá, sou o NaviBot, o ChatBot dos RH. Em que posso ajudar?",
    selectLanguageTitle: "Selecionar idioma",
    selectLanguageDescription:
      "Por favor, selecione o idioma no qual deseja receber a sua resposta.",
    selectLanguageLabel: "Selecione seu idioma preferido",
    apply: "Aplicar",
    cancel: "Cancelar",
    virtualAssistant: "Uma tecnologia pioneira em constante evolução.  \nQualquer questão adicional, contactar: [drh@thenavigatorcompany.com](mailto:drh@thenavigatorcompany.com)",
    anyQuestions: "Alguma pergunta? Escreva aqui",
    description: "Ficha",
    showExtendedAnswer: "Mostrar resposta estendida",
    hideExtendedAnswer: "Ocultar resposta estendida",
    details: "Detalhes",
    showCitations: "Mostrar citações",
    hideCitations: "Ocultar citações",
    receivedFeedback: "Feedback Recebido!",
    likedQuestion: "O que é que gostou nesta resposta?",
    dislikedQuestion: "O que é que pode ser melhorado?",
    submit: "Submeter",
    cancel: "Cancelar",
    feedbackPlaceholder: "Escreva o seu feedback...",
    unclearLabel: "Informação pouco clara",
    missingLabel: "Conteúdo incompleto",
    technicalLabel: "Linguagem demasiado técnica",
    usefulLabel: "Útil",
    feedbackPlaceholder: "Adicione mais detalhes (opcional)...",
    feedbackTitle: "Ajude-nos a melhorar, classificando a sua experiência:"
  },
  spanish: {
    title: "NaviBot - ChatBot de Recursos Humanos",
    welcomeMessage: "Hola, soy el NaviBot, el ChatBot de Recursos Humanos. ¿En qué puedo ayudarte?",
    selectLanguageTitle: "Selecciona preferencia de idioma",
    selectLanguageDescription:
      "Por favor, selecciona el idioma en el que deseas recibir tu respuesta.",
    selectLanguageLabel: "Selecciona tu idioma preferido",
    apply: "Aplicar",
    cancel: "Cancelar",
    virtualAssistant: "Una tecnología pionera en constante evolución.  \nCualquier pregunta adicional, contactar: [drh@thenavigatorcompany.com](mailto:drh@thenavigatorcompany.com)",
    anyQuestions: "¿Alguna pregunta? Escribe aquí",
    description: "Hoja de tema",
    showExtendedAnswer: "Mostrar respuesta extendida",
    hideExtendedAnswer: "Ocultar respuesta extendida",
    details: "Detalles",
    showCitations: "Mostrar citas",
    hideCitations: "Ocultar citas",
    receivedFeedback: "¡Comentario recibido!",
    likedQuestion: "¿Qué te gustó de esta respuesta?",
    dislikedQuestion: "¿Qué se podría mejorar?",
    submit: "Enviar",
    cancel: "Cancelar",
    feedbackPlaceholder: "Escribe tus comentarios...",
    unclearLabel: "Información poco clara",
    missingLabel: "Contenido incompleto",
    technicalLabel: "Lenguaje demasiado técnico",
    usefulLabel: "Útil",
    feedbackPlaceholder: "Agrega más detalles (opcional)...",
    feedbackTitle: "Ayúdanos a mejorar calificando tu experiencia:"
  }
};